const education = [
    {
        school: "Chandigarh University",
        degree: "Bachelor of Technology in Computer Science",
        year: "2020 - 2024",
        score: { label: "CGPA", value: "8.39 / 10" },
    },
    {
        school: "Good Shepherd Public School",
        degree: "12th Standard",
        year: "2020",
        score: { label: "Percentage", value: "92%" },
    },
    {
        school: "Good Shepherd Public School",
        degree: "10th Standard",
        year: "2018",
        score: { label: "Percentage", value: "91%" },
    },
];

export default education;
